import React from "react";
import { Link } from "react-router-dom";
import "../styles/inicio.css";

export const Inicio = () => {

  return (

    <main className="inicio">

      {/* ---- */}

      <section className="inicio-hero">

        <img
          className="inicio-hero__img"
          src="/img/baner01.png"
          alt="perti"
        />

        <div className="inicio-hero__contenido">

          <h1 className="inicio-hero__title">

            <span>Bienvenido a </span>

            <span>PertiSoft</span>

          </h1>

          <p className="inicio-hero__subtitle">

            Experiencia en Desrrollo de Software

          </p>

          <Link
          to="/reservar"
          className="inicio-hero__cta"
          >

            Contactanos

          </Link>

        </div>

      </section>



      {/* SERVICIOS */}

      <section className="inicio-servicios">

        <div className="inicio-servicios__grid">


          <article className="inicio-servicios__card">

            <div className="inicio-servicios__icon">

              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}

                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"

                />

              </svg>

            </div>

            <h2>Software Fácil de Usar</h2>

            <p>

              Software a medida

            </p>

          </article>



          <article className="inicio-servicios__card">

            <div className="inicio-servicios__icon">

              <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                <path strokeLinecap="round" strokeLinejoin="round"

                d="M8 2v4m0 12v4M8 18h4M8 6h3M8 10h4M8 14h3"/>

                <path strokeLinecap="round" strokeLinejoin="round"

                d="M16 2l2 20M16 2l4 6"/>

              </svg>

            </div>

            <h2>Atención Exclusiva</h2>

            <p>

              Capacitación con buena metodogía

            </p>

          </article>



          <article className="inicio-servicios__card">

            <div className="inicio-servicios__icon">

              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}

                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5"

                />

              </svg>

            </div>

            <h2>Procesos Rápidos</h2>

            <p>

              Obtienes reportes inmediatos

            </p>

          </article>


        </div>

      </section>



      {/* PLATOS DESTACADOS DINAMICOS */}

      <section className="inicio-platos">

        <div className="inicio-platos__wrap">

          <h2 className="inicio-platos__title">

            <span>Nuestras Aplicaciones </span>

            <span>Destacadas</span>

          </h2>


          <p className="inicio-platos__subtitle">

           Conoce nuestras aplicaciones en marcha

          </p>



          <div className="inicio-platos__grid">

             <article  className="inicio-platos__card"   key='2'>
                  <div className="inicio-platos__card-image">
                    <img src='/img/experiencias.png' alt="perti"/>
                  </div>
                  <div className="inicio-platos__card-body">
                    <h3 className="inicio-platos__card-title"> Experiencias Formativas </h3>
                    <p className="inicio-platos__card-desc">
                     Aplicacion para Institutos Públicos
                    </p>
                    <div className="inicio-platos__card-footer">
                      <p className="inicio-platos__card-price">
                        S/ ##
                      </p>
                      <Link to="/efrst"  className="inicio-platos__card-btn" >
                        Ver
                      </Link>
                    </div>
                  </div>
                </article>

                <article  className="inicio-platos__card"   key='2'>
                  <div className="inicio-platos__card-image">
                    <img src='/img/clavesol.png' alt="perti"/>
                  </div>
                  <div className="inicio-platos__card-body">
                    <h3 className="inicio-platos__card-title"> Clientes Sol </h3>
                    <p className="inicio-platos__card-desc">
                     Aplicación para Contadores
                    </p>
                    <div className="inicio-platos__card-footer">
                      <p className="inicio-platos__card-price">
                        S/ 0.00
                      </p>
                      <Link to="/contacto"  className="inicio-platos__card-btn" >
                        Ver
                      </Link>
                    </div>
                  </div>
                </article>
                <article  className="inicio-platos__card"   key='2'>
                  <div className="inicio-platos__card-image">
                    <img src='/img/horario.png' alt="perti"/>
                  </div>
                  <div className="inicio-platos__card-body">
                    <h3 className="inicio-platos__card-title"> Mis Horarios </h3>
                    <p className="inicio-platos__card-desc">
                     Aplicación Móvil para Horarios
                    </p>
                    <div className="inicio-platos__card-footer">
                      <p className="inicio-platos__card-price">
                        S/ 0.00
                      </p>
                      <Link to="/contacto"  className="inicio-platos__card-btn" >
                        Ver
                      </Link>
                    </div>
                  </div>
                </article>
                <article  className="inicio-platos__card"   key='2'>
                  <div className="inicio-platos__card-image">
                    <img src='/img/agenda.png' alt=''/>
                  </div>
                  <div className="inicio-platos__card-body">
                    <h3 className="inicio-platos__card-title"> Mi Agenda </h3>
                    <p className="inicio-platos__card-desc">
                     Aplicacion Movil para gestionar Agenda
                    </p>
                    <div className="inicio-platos__card-footer">
                      <p className="inicio-platos__card-price">
                        S/ 0.00
                      </p>
                      <Link to="/contacto"  className="inicio-platos__card-btn" >
                        Ver
                      </Link>
                    </div>
                  </div>
                </article>
          

          </div>



          <div className="inicio-platos__cta-wrap">

            <Link
            to="/contacto"
            className="inicio-platos__cta"
            >

              Contactanos

            </Link>

          </div>

        </div>

      </section>



      {/* CTA FINAL */}

      <section className="inicio-cta">

        <img
          className="inicio-cta__img"
          src="/img/baner02.png"
          alt=""
        />

        <div className="inicio-cta__contenido">

          <h2 className="inicio-cta__title">

            ¿Listo para una experiencia única?

          </h2>

          <p className="inicio-cta__text">

            Contactnos y solicita tu software

          </p>

          <Link
          to="/contacto"
          className="inicio-cta__btn"
          >

            Has tu pedido

          </Link>

        </div>

      </section>



    </main>

  );

};